import * as Sentry from "@sentry/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import posthog from "posthog-js";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (dsn) {
  Sentry.init({
    dsn,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.2,
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/intellr\.io/,
      /^https:\/\/www\.intellr\.io/,
      /^https:\/\/asia-south1-romeo-juliet-7\.cloudfunctions\.net/,
    ],
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
  });
}

const posthogKey = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: import.meta.env.VITE_POSTHOG_HOST ?? "https://ph.intellr.io",
    ui_host: "https://eu.posthog.com",    // proxy mode — links point back to PostHog EU
    defaults: "2026-01-30",
    person_profiles: "always",             // track all visitors for DAU/MAU
    capture_pageview: true,
    capture_pageleave: true,
    session_recording: {
      maskAllInputs: true,                // PII safety — mask all form inputs
    },
    loaded: (ph) => {
      if (import.meta.env.DEV) ph.opt_out_capturing();  // no dev noise
    },
  });
}

createRoot(document.getElementById("root")!).render(
  <>
    <App />
    <SpeedInsights />
  </>
);
